export default "__VITE_ASSET__a132258d__"